import { BlogTabsProps } from '@/types/blog.types';
import styles from './blogTabs.module.scss';

const BlogTabs = ({ activeTab, setActiveTab }: BlogTabsProps) => {
  return (
    <div className={styles.blogTabs}>
      <div className={styles.tabsWrapper}>
        <div
          className={`${styles.tabItem} ${
            activeTab === 'all' ? styles.activeTab : ''
          }`}
          onClick={() => setActiveTab('all')}
        >
          All Articles
        </div>
        <div
          className={`${styles.tabItem} ${
            activeTab === 'inThePress' ? styles.activeTab : ''
          }`}
          onClick={() => setActiveTab('inThePress')}
        >
          In the Press
        </div>
      </div>
    </div>
  );
};

export default BlogTabs;
